import css from "styled-jsx/css";

export default css`
.searcher-results {
  //border: 1px solid #d3d4d3;
  position: absolute;
  top: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  z-index: 21;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
  .result-item {
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 0.5rem 0.5rem;
  }
  .result-item:hover {
    background-color: #f2f2f2;
  }
  .result-item.focused {
    background-color: #f2f2f2;
  }
  &.hide {
    visibility: hidden;
  }
}
.searcher-results::-webkit-scrollbar {
  width: 9px;
}

.searcher-results::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 16px;
}

.searcher-results::-webkit-scrollbar-thumb {
  background: #dcdcdc;
  border-radius: 16px;
}

@supports not selector(::-webkit-scrollbar) {
  .searcher-results {
    scrollbar-color: #dcdcdc #ffffff;
  }
}
@media screen and (max-width: 768px) {
  .searcher-results {
    max-height: 320px;
    .result-item {
      min-height: 45px;
    }
  }
}
`;
